"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLink = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const config_1 = require("assets/styles/config");
exports.StyledLink = styled_components_1.default.a `
  color: ${config_1.colors.blurple};
  font: ${config_1.fontSizes.small} ${config_1.fontFamilies.primary};
  text-decoration: underline;
  cursor: pointer;
`;
